module.exports = __webpack_public_path__ + "img/title-zh.87a6969c.png";